const paths = {
  listSim: '/sim/list',
  editSim: '/sim/edit'
};

export default paths;
